import React, { ReactElement } from 'react'

import { Color } from '../../../../enums/color'
import { Icon } from '../../../Icon'
import { InputSize } from '../../types/size'
import { getIconSize } from '../../utils/getIconSize'
import * as Styled from './styles'

interface ClearInputButtonProps {
  inputSize?: InputSize
  onClick?: () => void
  onMouseDown?: () => void
}

export const ClearInputButton = ({ inputSize, onClick, onMouseDown, ...rest }: ClearInputButtonProps): ReactElement => (
  <Styled.ClearIconWrapper {...rest} onClick={onClick} onMouseDown={onMouseDown}>
    <Icon size={getIconSize(inputSize)} icon="circleX" color={Color.Grey800} />
  </Styled.ClearIconWrapper>
)
